function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { AppContext } from 'context';
import Link from 'components/Link';
import ArrowIcon from 'svg/ap/arrow.svg';
import styles from './MobilePage.pcss';
export const Header = ({ message, backToRouteName, onClick, queryParameters = '' })=>{
    const { getUrl } = useContext(AppContext);
    const url = useMemo(()=>backToRouteName && getUrl(backToRouteName), [
        backToRouteName
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.mobileHeader,
        children: /*#__PURE__*/ _jsx("div", {
            className: styles.mobileHeaderContent,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "d-flex align-items-center w-100",
                children: [
                    /*#__PURE__*/ _jsx(Link, {
                        to: onClick ? '' : `${url}${queryParameters}`,
                        onClick: onClick,
                        children: /*#__PURE__*/ _jsx(ArrowIcon, {
                            className: `${styles.mobileHeader__arrow} mr-4`
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text--center w-100 mr-4 pr-5",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, message))
                    })
                ]
            })
        })
    });
};
export default Header;
